import { render, staticRenderFns } from "./Dash-posts-feed.vue?vue&type=template&id=687e6107"
import script from "./Dash-posts-feed.vue?vue&type=script&lang=js"
export * from "./Dash-posts-feed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports